import React from 'react'

const CallFinishedGuest = () => {
  return (
    <div className='flex justify-center items-center w-[100vw] h-[100vh]'>
      <p>La llamada ha finalizado</p>
    </div>
  )
}

export default CallFinishedGuest
